/* les Enfants Sauvages - defilement fiable vers une section via l'URL (#ancre)
   sur la page de lancement.
   - Neutralise temporairement scroll-behavior:smooth du theme -> saut instantane
     (sinon l'animation smooth reste bloquee a 0 au chargement).
   - Double-saut par passe : le 1er saut colle la pile collante (header + sous-nav),
     le 2e recale la section juste sous cette pile (offset auto, desktop + mobile).
   - Plusieurs passes pour absorber le lazy-load (le contenu au-dessus grandit) ;
     s'arrete des que la position est stable, et s'annule si l'utilisateur scrolle.
   Alias propre : #ingredients -> section ingredients (cle stable les_ingredients_claude). */
(function () {
  'use strict';

  var ALIAS = {
    'ingredients': '[id*="les_ingredients_claude" i]',
    'ingredient':  '[id*="les_ingredients_claude" i]'
  };

  function target() {
    var h = (location.hash || '').replace(/^#/, '').toLowerCase();
    if (!h) return null;
    if (ALIAS[h]) return document.querySelector(ALIAS[h]);
    try { return document.getElementById(decodeURIComponent(location.hash.slice(1))); }
    catch (e) { return null; }
  }

  function navOffset() {
    var nav = document.querySelector('[id*="__nav"], [class*="lancement-nav" i]');
    if (!nav) return 8;
    var s = getComputedStyle(nav);
    if (s.position !== 'sticky' && s.position !== 'fixed') return 8;
    var r = nav.getBoundingClientRect();
    // nav collee en haut -> son bas = bas de toute la pile collante (header + sous-nav)
    if (r.bottom > 0 && r.bottom < window.innerHeight * 0.4) return r.bottom + 8;
    return r.height + 8;
  }

  function targetY(el) {
    var top = el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0);
    return Math.max(0, Math.round(top - navOffset()));
  }

  function jump(y) {
    var de = document.documentElement, prev = de.style.scrollBehavior;
    de.style.scrollBehavior = 'auto'; // neutralise le smooth du theme -> saut instantane
    window.scrollTo(0, y);
    de.style.scrollBehavior = prev;
  }

  function scrollToTarget() {
    var el = target(); if (!el) return null;
    jump(targetY(el));   // 1er saut : colle la pile collante
    var y = targetY(el);
    jump(y);             // 2e saut : recale sous la pile collante
    return y;
  }

  function run() {
    if (!location.hash || !target()) return;
    var cancelled = false, lastY = -1, stable = 0;
    function onUser() { cancelled = true; off(); }
    function off() { ['wheel', 'touchstart', 'keydown'].forEach(function (ev) { window.removeEventListener(ev, onUser, true); }); }
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) { window.addEventListener(ev, onUser, true); });

    [250, 600, 1200, 2200, 3200].forEach(function (d) {
      setTimeout(function () {
        if (cancelled) return;
        var y = scrollToTarget();
        if (y == null) return;
        if (y === lastY) { if (++stable >= 2) off(); } else { stable = 0; lastY = y; }
      }, d);
    });
    setTimeout(off, 3600);
  }

  if (document.readyState === 'complete') { run(); }
  else { window.addEventListener('load', run); }

  // clics internes vers nos alias uniquement (ne touche pas la nav native #les-packs, etc.)
  window.addEventListener('hashchange', function () {
    var h = (location.hash || '').replace(/^#/, '').toLowerCase();
    if (!ALIAS[h]) return;
    scrollToTarget();
  });
})();
